var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sales-coupon",
      class: _vm.customClasses,
      style: _vm.inlineStyles,
    },
    [
      _c(
        "div",
        { staticClass: "codeHolder" },
        [
          _vm.icon
            ? _c("div", {
                staticClass: "ico",
                domProps: { innerHTML: _vm._s(_vm.inlineSvg) },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "labeling" }, [
            _vm.countdownPosition == 0 && _vm.countdownText != ""
              ? _c("span", {
                  staticClass: "countdown",
                  domProps: { innerHTML: _vm._s(_vm.countdownText) },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "headlineContainer",
              domProps: { innerHTML: _vm._s(_vm.headingText) },
            }),
          ]),
          _vm._v(" "),
          _vm._t("additionalContent"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "codeButton withLabel",
              attrs: {
                "data-text": _vm.$translate(
                  "biokinderDesign::Sale.bkSalesCouponButtonLabel"
                ),
              },
            },
            [
              _vm.moreinfo != ""
                ? _c("span", {
                    staticClass: "moreInfo",
                    domProps: { innerHTML: _vm._s(_vm.moreinfo) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.countdownPosition == 2 && _vm.countdownText != ""
                ? _c("span", {
                    staticClass: "countdown",
                    domProps: { innerHTML: _vm._s(_vm.countdownText) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "codeField", on: { click: _vm.copy } },
                [
                  _c("i", {
                    staticClass: "fa",
                    class: {
                      "fa-check": _vm.codeActive,
                      "fa-copy": !_vm.codeActive,
                    },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "code",
                    domProps: { innerHTML: _vm._s(_vm.code) },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.details
            ? _c(
                "button",
                {
                  staticClass: "viewDetails collapsed",
                  attrs: {
                    "data-toggle": "collapse",
                    "data-target": "#couponDetails_" + _vm._uid,
                    "aria-expanded": "false",
                    "aria-controls": "couponDetails",
                  },
                },
                [_c("i", { staticClass: "fa fa-chevron-down" })]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.details
        ? _c(
            "div",
            {
              staticClass: "collapse couponDetails",
              attrs: { id: "couponDetails_" + _vm._uid },
            },
            [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.couponDetailsText) },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }